// extracted by mini-css-extract-plugin
module.exports = {"margin":"SendNoteDialogStyles_margin__d9L0_","buttons":"SendNoteDialogStyles_buttons__1dzW6","marginLeft":"SendNoteDialogStyles_marginLeft__26gki"};